import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { I18nextProvider } from 'react-i18next'
import WebFont from 'webfontloader'

import './index.css'
import i18n from './i18n'
import App from './App'
import registerServiceWorker from './registerServiceWorker'

WebFont.load({
    custom: {
        families: ['Stem']
    },
    google: {
        families: ['Montserrat:400,600:cyrillic,latin&display=swap']
    },
    events: false
})

ReactDOM.render(
    <I18nextProvider i18n={ i18n }>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </I18nextProvider>,
  document.getElementById('root')
)

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js